module.exports = __webpack_public_path__ + "assets/media/extension.89308ec1.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/extension.svg
// module id = 2025
// module chunks = 0